import { SVGProps, Ref, forwardRef } from 'react';

export const BuildingFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.13 16H5.833c-2.356 0-3.609 0-4.4-.644l-.152-.137c-.683-.684-.768-1.731-.779-3.667L.5 0h8.63zm-6.42-5.38v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4zm-2.8-2.8v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4zm-2.8-2.8v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4zm-2.8-2.8v1.4h1.4v-1.4zm2.8 0v1.4h1.4v-1.4z"
                fill="currentColor"
            />
            <path
                d="M15.5 10.667c0 2.514 0 3.77-.78 4.552-.733.732-1.946.745-2.922.768-.38.01-.8.011-1.268.012V11.09h2.525v-1.4H10.53v-1.4h2.525v-1.4H10.53V4.667h4.97z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BuildingFilledSize16Glyph.displayName = 'BuildingFilledSize16Glyph';
